import controller from './my-preferences.controller'
import template   from './my-preferences.html'
import './my-preferences.styl'

let component = {
  restrict: 'E',
  controller,
  template
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/profile/my-profile/my-preferences/my-preferences.component.js